import { KeywordStatShowItem } from '../api/RestApiManager';
import { RefinePhraseQuery } from '../typings/graphql-grid';
import { PhrasesSelectorListItem, PhrasesSelectorPhrase, PhrasesSelectorStartPhraseNode } from '../typings/phrases';

export const mapPhraseToPhrasesSelectorListItem = ({
    phrase,
    shows
}: KeywordStatShowItem): PhrasesSelectorListItem => ({
    text: phrase,
    shows,
    selected: false
});

export const mapStringToPhrasesSelectorListItem = (text: string): PhrasesSelectorListItem => ({
    text,
    shows: 0,
    selected: false
});

export const splitOneSelectorListItemToSeveral = (el: PhrasesSelectorListItem): Array<PhrasesSelectorListItem> =>
    el.text.split(' ').map(mapStringToPhrasesSelectorListItem);

export const mapRefineWords = ({
    refineKeyword
}: RefinePhraseQuery): {
    hasMore: boolean;
    words: Array<PhrasesSelectorPhrase>;
} => {
    const { hasMore, words } = refineKeyword;
    const wordsList: Array<PhrasesSelectorPhrase> = [];

    const resultWords = words
        ? words.reduce((acc, word) => {
              if (word) {
                  acc.push({
                      name: word.word ? `-${word.word}` : '',
                      shows: Number(word.count)
                  });
              }

              return acc;
          }, wordsList)
        : wordsList;

    return {
        words: resultWords,
        hasMore
    };
};

export const mapPhraseNodeToPhrase = (phrase: PhrasesSelectorStartPhraseNode): PhrasesSelectorPhrase => {
    return {
        name: phrase.name,
        shows: phrase.info.shows
    };
};
